module.exports = __webpack_public_path__ + "media/images/pic/brodno/brodno_kids-f7f9af8e8fbb54163058d408063873d8.svg";